<template>
	<div class="nagios-dash">
		<h1>System Health &amp; Availability</h1>
		<ul class="hostlist">
			<li class="host" v-for="(value, key) in hostList" v-bind:key="key">
				<div class="host-detail">
					<div class="host-status" v-bind:class="value.host.status | asHostCssClass"></div>
					{{ key }}
				</div>
				<div class="servicelist">
					<div class="service" v-for="service in value.services" v-bind:key="service.name">
						<div class="service-status" v-bind:class="service.status | asServiceCssClass"></div>
						{{ service.description }}
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let refreshInterval = null;
	let newAlert = new Audio("sounds/new-alert.wav");
	let clearAlert = new Audio("sounds/clear-alert.wav");

	export default {
		name: 'NagiosDash',
		data() {
			return {
				hostList: {},
				problemCount: 0
			}
		},

		filters: {
			asHostCssClass: function (value) {
				switch (value) {
					case 0:
						return "up";
					case 1:
						return "down";
					case 2:
						return "unreachable";
					default:
						return "";
				}
			},
			asServiceCssClass: function (value) {
				switch (value) {
					case 0:
						return "ok";
					case 1:
						return "warning";
					case 2:
						return "critical";
					case 3:
						return "unknown";
					default:
						return "";
				}
			}
		},

		mounted() {
			console.log("Nagios dash module initiated");
			const self = this;
			this.getStatus();
			refreshInterval = setInterval(this.getStatus, 1000 * 30);
			window.addEventListener('nagiosFull', (e) => {
				self.updateStatus(e.detail);
			});
		},
		
		destroyed() {
			console.log("Stopping Nagios dash module");
			window.removeEventListener('nagiosFull', (e) => {
				self.updateStatus(e.detail);
			});
			clearInterval(refreshInterval);
		},
		
		methods: {
			getStatus() {
				let self = this;
				this.$http.get('/icinga/full').then(response => {
					let data = response.body;
					self.updateStatus(data);
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});
			},

			updateStatus(data) {
				this.hostList = data.hosts;
				if (data.problemCount > this.problemCount) {
					//this.soundNewAlert();
				} else if (data.problemCount < this.problemCount) {
					//this.soundClearAlert();
				}
				this.problemCount = data.problemCount;
			},

			soundNewAlert() {
				if (!window.audio) return;
				newAlert.currentTime = 0;
				newAlert.play();
			},

			soundClearAlert() {
				if (!window.audio) return;
				clearAlert.currentTime = 0;
				clearAlert.play();
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	@bg-nagios: #DBDBDB;
	@normal: #090;
	@warning: #FC6;
	@critical: #D00;
	@unknown: #D60;

	.nagios-dash {
		font-family: @font-main;
		padding: 1.5em;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		color: #fff;

		h1 {
			text-transform: uppercase;
			font-size: 2.6em;
			line-height: 1em;
			padding: 0 0 0.4em;
			margin: 0;
		}

		.hostlist {
			column-count: 10;
			column-width: auto;
			list-style: none;
			margin: 0;
			padding: 0;

			li {
				break-inside: avoid;
			}
		}

		.host {
			width: 100%;
			padding-bottom: 1em;
		}

		.host-detail {
			position: relative;
			padding: 0.3em 0.5em 0.3em 2em;
			margin-bottom: 0.1em;
			font-weight: 700;
			font-size: 0.75em;
		}

		.host-status {
			position: absolute;
			left: 0;
			top: 0.2em;
			bottom: 0.2em;
			width: 1.5em;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			display: block;
			border-radius: 0.3em;
		}

		.service {
			position: relative;
			color: #000;
			border-radius: 0.3em;
			background-color: @bg-nagios;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
			font-size: 0.75em;
			margin-bottom: 1px;
			padding: 0.3em 0.5em 0.3em 2em;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.service-status {
			position: absolute;
			width: 1.6em;
			top: 0;
			left: 0;
			bottom: 0;
		}

		.host-status,
		.service-status {
			&.up,
			&.ok {
				background-color: @normal;
			}

			&.warning {
				background-color: @warning;
			//	animation: warning 1.5s infinite;
			}

			&.critical {
				color: #fff;
				background-color: @critical;
			//	animation: critical 1.5s infinite;
			}

			&.unreachable,
			&.unknown {
				color: #fff;
				background-color: @unknown;
			//	animation: unknown 1.5s infinite;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// nagios-dash.vue?4edfed72